import { toImageUrl } from '../utils/format.util';
import { snapshotExists } from '../utils/snapshot.util';

export default class PlayersService {
  constructor(firebase) {
    this.firebase = firebase;
  }

  async getPlayer(id) {
    if (id.includes('/')) {
      return null;
    }

    const doc = await this.firebase.firestore()
      .collection('players')
      .doc(id)
      .get();

    if (!snapshotExists(doc)) {
      return null;
    }

    const player = {
      ...doc.data(),
      id: doc.id,
      image: doc.data() && doc.data().keyCard && doc.data().keyCard.id ? toImageUrl(`cards/thumb_${doc.data().keyCard.id}`) : null,
      icon: 'account_circle',
    };

    return player;
  }
}
